<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    window.onresize = ()=>{
      this.resize()
    }
  },
  created() {
    this.resize()
  },
  methods:{
    resize(){
      var scale = 1
      scale = (window.innerWidth)/1920
      document.body.style.width = '1920px'
      document.body.style.transform = `scale(${scale})`
      document.body.style.transformOrigin = `0 0`
      document.body.style.height = `${100/scale}%`
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,body{
  width: 100%;
  height: 100%;
  padding-right: 0px!important;
  overflow: hidden;
}
@media screen and ( max-height: 1100px )  {
  html{
    font-size: 10px;
  }
}
@media screen and ( min-height: 1100px ) and ( max-height: 1500px ) {
  html{
    font-size: 15px;
  }
}
@media screen and ( min-height: 1500px ){
  html{
    font-size: 20px;
  }
}
.anchorBL{
  display: none!important;
}
.outside .ec-extension-bmap{
  background-color: #003267!important;
}
.outside .BMap_mask{
  box-shadow: 0 0 40px 40px rgba(4 ,27 ,58 ,1) inset !important;
}
.el-icon-loading{
  font-size:20px!important;
}
.el-loading-text{
  font-size: 20px!important;
}

/* 全局表格表头工业风样式 */
.el-table th.el-table__cell {
  background-color: #3d4f5f !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  border-bottom: 2px solid #2c3e50 !important;
  padding: 12px 0 !important;
}

.el-table th.el-table__cell .cell {
  color: #ffffff !important;
  font-weight: 600 !important;
}

.el-table th.el-table__cell:hover {
  background-color: #4a5d6d !important;
}

/* 表格内容行样式 */
.el-table td.el-table__cell {
  padding: 10px 0 !important;
  font-size: 13px !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f5f7fa !important;
}

.el-table__body tr:hover > td.el-table__cell {
  background-color: #e8ecef !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue